export default "__VITE_ASSET__eeypAUhd__"